<div class="alignContent">
  <viz-http-status code="500"></viz-http-status>
</div>
